﻿export class FileUploadBadFileFormat {
    static eventName() { return 'FileUploadBadFileFormat'; }
    eventName = FileUploadBadFileFormat.eventName;

    constructor(public transferId: string) { }
}
